export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://api.phenogenesis.com';

export const WS_BASE_URL =
  import.meta.env.VITE_WS_BASE_URL || 'https://api.phenogenesis.com';

export const GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

export const GOOGLE_MAPS_MAP_ID =
  import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '';


if (import.meta.env.DEV) {
  if (GOOGLE_MAPS_API_KEY) {
    console.log('✅ Google Maps API Key loaded:', GOOGLE_MAPS_API_KEY.substring(0, 10) + '...');
  } else {
    console.error('❌ VITE_GOOGLE_MAPS_API_KEY is not set in .env file. Google Maps will not work.');
    console.log('💡 Make sure:');
    console.log('   1. .env file exists in project root');
    console.log('   2. VITE_GOOGLE_MAPS_API_KEY=your_key_here is in .env');
    console.log('   3. Dev server was restarted after adding .env');
  }
}

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    REGISTER_DRIVER: '/auth/register/driver',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    VERIFY_PHONE: '/auth/verify/phone',
    VERIFY_EMAIL: '/auth/verify/email',
    RESEND_VERIFICATION: '/auth/resend-verification',
    VERIFICATION_STATUS: '/auth/verification/status',
    DRIVER_DOCUMENTS: '/auth/driver/documents',
    UPLOAD_DOCUMENT: '/auth/driver/documents/upload',
    DRIVER_VERIFICATION_STATUS: '/auth/driver/verification/status',
  },
  USERS: {
    PROFILE: '/users/profile',
    UPDATE_PROFILE: '/users/profile',
    UPDATE_LOCATION: '/users/location',
    UPLOAD_PROFILE_PICTURE: '/users/profile/picture',
  },
  RIDES: {
    CREATE: '/rides',
    LIST: '/rides',
    DETAIL: '/rides/:id',
    CANCEL: '/rides/:id/cancel',
    ESTIMATE: '/rides/estimate',
    ACCEPT: '/rides/:id/accept',
    REJECT: '/rides/:id/reject',
    START: '/rides/:id/start',
    COMPLETE: '/rides/:id/complete',
    ARRIVE: '/rides/:id/arrived',
    CURRENT: '/rides/passenger/active',
    DRIVER_ACTIVE: '/rides/driver/active',
    DRIVER_HISTORY: '/rides/driver/my-rides',
    HISTORY: '/rides/passenger/my-rides',
  },
  DRIVERS: {
    STATUS: '/drivers/status',
    LOCATION: '/drivers/location',
    VEHICLES: '/drivers/vehicles',
    VEHICLE_UPDATE: '/drivers/vehicles/:id',
    VEHICLE_DELETE: '/drivers/vehicles/:id',
    EARNINGS: '/drivers/earnings',
    STATS: '/drivers/stats',
  },
  PAYMENTS: {
    METHODS: '/payments/methods',
    WALLET: '/payments/wallet/balance',
    WALLET_HISTORY: '/payments/wallet/history',
    ADD_MONEY: '/payments/wallet/funds',
    TRANSACTIONS: '/payments/history',
  },
  RATINGS: {
    CREATE: '/ratings',
    LIST: '/ratings',
  },
  CHAT: {
    CONVERSATIONS: '/chat/conversations',
    MESSAGES: '/chat/conversations/:id/messages',
    SEND: '/chat/conversations/:id/messages',
  },
  VEHICLE_TYPES: {
    LIST: '/vehicle-types',
  },
  VEHICLE_BRANDS: {
    LIST: '/vehicle-brands',
    MODELS: '/vehicle-brands/:id/models',
  },
  SOS: {
    CREATE: '/sos',
    LIST: '/sos',
  },
  SERVICES: {
    LIST: '/services',
    SUGGESTED_DESTINATIONS: '/rides/passenger/suggested-destinations',
  },
};

